const NAMESPACE = "signatoryTagErrorsDialog";

const KEYS = {
    addedSignatoriesHeader: "addedSignatoriesHeader",
    removedSignatoriesHeader: "removedSignatoriesHeader",
    associatedESignatureEnvelopesHeader: "associatedESignatureEnvelopesHeader"
};

const MESSAGES = {
    [KEYS.addedSignatoriesHeader]: {
        value: "Added Signatories:",
        comment: "Added Signatories header"
    },
    [KEYS.removedSignatoriesHeader]: {
        value: "Removed Signatories:",
        comment: "Removed Signatories header"
    },
    [KEYS.associatedESignatureEnvelopesHeader]: {
        value: "Associated eSignature Envelopes:",
        comment: "Associated ESignature Envelopes header"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
